import { useLocation, useNavigate } from "react-router-dom";
import { INVOICE_SETUP_OPTIONS } from "../constants/_constant";
import "../css/InvoiceMain.css";
import InvoiceTable from "./InvoiceTable";
import PaymentVoucher from "./PaymentVoucher";
import PaymentVoucherTable from "./PaymentVoucherTable";

const InvoiceMain = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Extracting individual query parameters
  const selectedOption = queryParams.get("option");
  const mode = queryParams.get("mode");
  const id = queryParams.get("id");

  const handleNavigate = (option) => {
    navigate(`/new/invoice?option=${option}`);
  };

  return (
    <div className="cu-invoice-options-main">
      <div className="cu-invoice-options-menu">
        {INVOICE_SETUP_OPTIONS?.map((opt) => (
          <div
            className={`cu-invoice-option ${
              selectedOption === opt?.query ? "cu-invoice-option-active" : ""
            }`}
            key={opt?.id}
            onClick={() => handleNavigate(opt?.query)}
          >
            {opt?.label}
          </div>
        ))}
      </div>
      {selectedOption === "invoice" && <InvoiceTable />}
      {selectedOption === "paymentvoucher" && mode && <PaymentVoucher mode={mode} id={id}/>}
      {selectedOption === "paymentvoucher" && !mode && <PaymentVoucherTable />}
    </div>
  );
};

export default InvoiceMain;
